$(document).ready(function (e) {
	$('body').on('hidden.bs.modal', '.modal', function () {
		$(this).removeData('bs.modal');
	});

	$(document).on('submit', 'form[data-remote="true"]', function (e) {
		var form = $(this);

		form.find('[type="submit"]')
			.html('<span class="spinner-grow spinner-grow-sm"></span> Идёт отправка')
			.attr('disabled', 'disabled');

		jQuery.ajax({
			url: form.attr('action'),
			type: form.attr('method'),
			data: form.serialize(),
			dataType: 'html',
			success: function (result) {
				$(form.parents('.modal-content')[0]).html(result);
			}
		});

		e.preventDefault();
	});
	
});


// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
	'use strict';
	window.addEventListener('load', function () {
		// Fetch all the forms we want to apply custom Bootstrap validation styles to
		var forms = document.getElementsByClassName('needs-validation');
		// Loop over them and prevent submission
		var validation = Array.prototype.filter.call(forms, function (form) {
			form.addEventListener('submit', function (event) {
				if (form.checkValidity() === false) {
					event.preventDefault();
					event.stopPropagation();
				}
				form.classList.add('was-validated');
			}, false);
		});
	}, false);
})();


$('body').on('click.modal.data-api', '[data-toggle="modal"]', function () {
	$($(this).data("target") + ' .modal-content').load($(this).attr('data-remote'));
});


$(document).ready(function () {
	$('#maskForm')
		.bootstrapValidator({
			feedbackIcons: {
				valid: 'icon icon-check',
				invalid: 'icon icon-remove',
				validating: 'icon icon-refresh'
			},
			fields: {
				server: {
					validators: {
						ip: {
							message: 'Geben Sie die richtige IP-Adresse ein'
						}
					}
				}
			}
		})
		.find('[name="server"]').mask('099.099.099.099');
});


$(document).ready(function () {
	$('[data-toggle="popover"]').popover();
});

$("[data-trigger]").on("click", function () {
	var trigger_id = $(this).attr('data-trigger');
	$(trigger_id).toggleClass("show");
	$('body').toggleClass("offcanvas-active");
});

// close button 
$(".btn-close").click(function (e) {
	$(".navbar-collapse").removeClass("show");
	$("body").removeClass("offcanvas-active");
});



$(window).scroll(function () {
	$('nav').toggleClass('scrolled', $(this).scrollTop() > 50);
});